import OktaIcon from 'components/core/icons/okta.svg'
import Image from 'components/core/image'
import React from 'react'

const Okta = (): React.ReactElement => {
    return <Image src={OktaIcon.src} height={24} width={24} />
}

export default Okta
